import { createApi } from '@reduxjs/toolkit/query/react';

import { CollectOwnership } from '@/slices/collectOwnerships/collectOwnerships.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

const collectOwnershipsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/enterprises',
  }),
  reducerPath: 'collectOwnerships',
  tagTypes: ['CollectOwnerships'],
  endpoints: (build) => ({
    getCollectOwnerships: build.query<
      CollectOwnership[],
      {
        enterpriseId: string;
        indicatorIds?: string[];
        dimensionItemIds?: string[];
      }
    >({
      query: ({ enterpriseId, ...params }) => ({
        url: `/${enterpriseId}/collect-ownerships`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: {
        collectOwnerships: CollectOwnership[];
      }) => response.collectOwnerships,
      providesTags: (_result, _error, { enterpriseId }) => [
        { type: 'CollectOwnerships', id: enterpriseId },
      ],
    }),
  }),
});

export default collectOwnershipsApi;
